import client from "./client";

const paperApi = {
  list(params = {}) {
    return client.get("/ai/question-paper", { params }).then((r) => r.data);
  },
  save(data) {
    return client.post("/ai/question-paper", data).then((r) => r.data);
  },
  remove(id) {
    return client.delete(`/ai/question-paper/${id}`).then((r) => r.data);
  },
};

export default paperApi;
